import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function fmtNum(v) {
  if (v == null || v === "") return "";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString("en-US");
}


function fmt(v) {
  if (v == null) return "";
  return String(v);
}

function pad(n) {
  const x = String(n || "");
  return x.length === 1 ? `0${x}` : x;
}

function formatDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return fmt(d);
  return `${pad(dt.getDate())}-${["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][dt.getMonth()]}-${dt.getFullYear()}`;
}

export default function generateAirCargoDetailsPdf(payload) {
  const header =
    payload?.header ||
    payload?.data?.header ||
    {};

  const items =
    Array.isArray(payload?.items) ? payload.items :
    Array.isArray(payload?.bols) ? payload.bols :
    Array.isArray(payload?.data?.items) ? payload.data.items :
    Array.isArray(payload?.data?.bols) ? payload.data.bols :
    [];

  const totals =
    payload?.totals ||
    payload?.data?.totals ||
    {
      total_bols: items.length,
      total_packages: items.reduce((s, x) => s + Number(x?.number_of_packages || 0), 0),
      total_gross_mass: items.reduce((s, x) => s + Number(x?.gross_mass || 0), 0),
    };

  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();

  doc.setFontSize(16);
  doc.text("Air Cargo Manifest", pageW / 2, 40, { align: "center" });
  doc.setFontSize(10);
  doc.text("I.C.A.O. Annex 9, Appendix 3", pageW / 2, 56, { align: "center" });

  doc.setFontSize(10);
  const leftX = 40;
  const rightX = pageW - 40;
  const y0 = 80;

  doc.text(`Owner or Operator: ${fmt(header.owner_operator || "")}`, leftX, y0);
  doc.text(`Manifest No: ${fmt(header.id || "")}`, rightX, y0, { align: "right" });

  doc.text(`Registration: ${fmt(header.registration || "")}`, leftX, y0 + 14);
  doc.text(`Customs Ref: ${fmt(header.customs_ref || "")}`, rightX, y0 + 14, { align: "right" });

  doc.text(`Point of Loading: ${fmt(header.place_of_departure_code || "")}`, leftX, y0 + 28);
  doc.text(`Point of Unloading: ${fmt(header.place_of_destination_code || "")}`, rightX, y0 + 28, { align: "right" });

  doc.text(
    `Flight No./Date: ${fmt(header.flight_no || "")}   ${formatDate(header.date_of_arrival || "")}`,
    leftX,
    y0 + 42
  );

  const body = items.map((b) => [
    fmt(b.hawb_no || b.mawb_no || b.awb_no || b.bol_reference),
  fmtNum(b.number_of_packages),
fmtNum(b.gross_mass),
    fmt(b.goods_description),
   fmt(`${header.place_of_departure_code || ""} - ${header.place_of_destination_code || ""}`),

    fmt(b.official_use || ""),
  ]);

autoTable(doc, {
  startY: y0 + 58,
  theme: "grid",
  head: [["AIR WAYBILL", "PIECES", "WEIGHT", "NATURE OF GOODS", "OPERATOR", "OFFICIAL USE"]],
  body,
  styles: { fontSize: 9, cellPadding: 3 },

  headStyles: {
    fontStyle: "bold",
    fillColor: [30, 136, 229], // 🔵 أزرق
    textColor: 255,
  },

  columnStyles: {
    0: { cellWidth: (pageW - 80) * 0.19 },
    1: { cellWidth: (pageW - 80) * 0.10, halign: "right" },
    2: { cellWidth: (pageW - 80) * 0.12, halign: "right" },
    3: { cellWidth: (pageW - 80) * 0.29 },
    4: { cellWidth: (pageW - 80) * 0.14 },
    5: { cellWidth: (pageW - 80) * 0.16 },
  },
});


  // ✅ Totals under table
  const afterY = (doc.lastAutoTable?.finalY || (y0 + 58)) + 18;
  doc.setFontSize(10);
  doc.text(
    `Totals  |  No. of AWBs: ${fmtNum(totals.total_bols)}   Pieces: ${fmtNum(totals.total_packages)}   Weight: ${fmtNum(totals.total_gross_mass)}`,
    leftX,
    afterY
  );

  const fileKey = fmt(header.flight_no || header.id || "");
  doc.save(`air_cargo_manifest_${fileKey}.pdf`);
}
